import { Box, Button, Stack, Typography } from '@mui/material';
import AdminPanelSettingsRounded from '@mui/icons-material/AdminPanelSettingsRounded';
import SchoolRounded from '@mui/icons-material/SchoolRounded';
import SupervisorAccountRounded from '@mui/icons-material/SupervisorAccountRounded';
import BackpackRounded from '@mui/icons-material/BackpackRounded';

/** Accounts created by `python -m app.cli seed --demo` in the back-end. */
const DEMO_ACCOUNTS = [
  { label: 'Admin', email: 'admin@lousa.example', icon: AdminPanelSettingsRounded },
  { label: 'Coordenação', email: 'coordenacao@lousa.example', icon: SupervisorAccountRounded },
  { label: 'Professora', email: 'professora@lousa.example', icon: SchoolRounded },
  { label: 'Aluno', email: 'aluno@lousa.example', icon: BackpackRounded },
] as const;
const DEMO_PASSWORD = 'lousa1234';

/** One-click demo sign-in. Shown only when VITE_DEMO_LOGINS=true (never in production). */
export function DemoLogins({
  disabled,
  onPick,
}: {
  disabled?: boolean;
  onPick: (email: string, password: string) => void;
}) {
  return (
    <Box
      sx={(theme) => ({
        mt: 3,
        p: 2,
        borderRadius: 3,
        border: `1px dashed ${theme.vars.palette.divider}`,
        bgcolor: 'background.subtle',
      })}
    >
      <Typography variant="overline" color="text.secondary" component="p">
        Contas de demonstração
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 1 }}>
        {DEMO_ACCOUNTS.map(({ label, email, icon: Icon }) => (
          <Button
            key={email}
            variant="tonal"
            size="small"
            startIcon={<Icon fontSize="small" />}
            disabled={disabled}
            onClick={() => onPick(email, DEMO_PASSWORD)}
            sx={{ flex: 1 }}
          >
            {label}
          </Button>
        ))}
      </Stack>
      <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1 }}>
        Senha de todas: <code>{DEMO_PASSWORD}</code>
      </Typography>
    </Box>
  );
}
